module.exports = __webpack_public_path__ + "static/media/blot_bg_img.8b060759.svg";